module.exports = __webpack_public_path__ + "img/9.fab8a7cf.png";